import { buildProps } from '@xzx-design/utils'
import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Lottie from './lottie.vue'

export const lottieProps = buildProps({
  progress: {
    type: [Number, String],
    default: undefined,
  },
  width: {
    type: [String, Number],
    default: 200,
  },
  height: {
    type: [String, Number],
    default: 200,
  },
  data: {
    type: JSON || Object,
    default: () => ({}),
  },
  loop: {
    type: Boolean,
    default: false,
  },
  autoplay: {
    type: Boolean,
    default: true,
  },
  renderer: {
    type: String,
    values: ['svg', 'canvas', 'html'],
    default: 'svg',
  },
})

export const lottieEmits = {
  'update:progress': Number,
}

export type LottieProps = ExtractPropTypes<typeof lottieProps>
export type LottieInstance = InstanceType<typeof Lottie>
export type LottieEmits = typeof lottieEmits
